import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

interface DateRangeFilterProps {
  startDate: string;
  endDate: string;
  onStartDateChange: (value: string) => void;
  onEndDateChange: (value: string) => void;
  className?: string;
}

export function DateRangeFilter({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  className,
}: DateRangeFilterProps) {
  const { t } = useTranslation();

  return (
    <div className={cn('flex items-center gap-2', className)}>
      <label className='text-sm text-gray-500'>{t('submissions.filters.dateFrom')}</label>
      <input
        type='date'
        value={startDate}
        max={endDate || undefined}
        onChange={(e) => onStartDateChange(e.target.value)}
        className='px-3 py-2 border border-gray-300 rounded-md text-sm bg-white focus:ring-primary focus:border-primary'
      />
      <span className='text-sm text-gray-500'>{t('submissions.filters.dateTo')}</span>
      <input
        type='date'
        value={endDate}
        min={startDate || undefined}
        onChange={(e) => onEndDateChange(e.target.value)}
        className='px-3 py-2 border border-gray-300 rounded-md text-sm bg-white focus:ring-primary focus:border-primary'
      />
    </div>
  );
}
